<template>
  <div>
    <DepartmentLiquidation
      :title="'CHEQUE FUND MONITORING'"
    />
  </div>
</template>
<script>
  import DepartmentLiquidation
    from '@/views/view_interface/monitoring/fund_monitoring/ChequeDepartmentFundMonitoring'

  export default {
    components: {
      DepartmentLiquidation,
    },
  }
</script>
